import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Lock, Calendar, Users } from 'lucide-react';

const MaintenancePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-yellow-50 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full shadow-2xl">
        <CardContent className="p-12 text-center">
          {/* Logo / Icône */}
          <div className="mb-8 flex justify-center">
            <div className="w-24 h-24 bg-gradient-to-br from-purple-600 via-red-500 to-yellow-500 rounded-full flex items-center justify-center">
              <Lock className="w-12 h-12 text-white" />
            </div>
          </div>

          {/* Titre */}
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-purple-600 via-red-500 to-yellow-500 bg-clip-text text-transparent">
            Alliance Solidarité
          </h1>

          {/* Message principal */}
          <p className="text-xl text-gray-600 mb-8">
            Site en cours de finalisation
          </p>

          {/* Informations */}
          <div className="bg-gradient-to-r from-purple-100 via-pink-100 to-yellow-100 rounded-lg p-6 mb-8">
            <div className="flex items-center justify-center gap-2 mb-3">
              <Calendar className="w-5 h-5 text-purple-600" />
              <p className="text-gray-700 font-medium">
                Ouverture prochaine au public
              </p>
            </div>
            <p className="text-sm text-gray-600">
              Notre équipe travaille activement pour vous offrir la meilleure expérience
            </p>
          </div>

          {/* Badge Testeurs */}
          <div className="flex items-center justify-center gap-2 mb-8 text-sm text-gray-500">
            <Users className="w-4 h-4" />
            <span>Phase de test en cours avec nos administrateurs</span>
          </div>

          {/* Bouton de connexion */}
          <Button
            onClick={() => navigate('/login')}
            size="lg"
            className="w-full md:w-auto bg-gradient-to-r from-purple-600 via-red-500 to-yellow-500 hover:from-purple-700 hover:via-red-600 hover:to-yellow-600 text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all"
          >
            <Lock className="w-5 h-5 mr-2" />
            Connexion Administrateur
          </Button>

          {/* Message bas de page */}
          <p className="text-xs text-gray-400 mt-8">
            Accès réservé aux testeurs autorisés
          </p>
        </CardContent>
      </Card>

      {/* Footer */}
      <div className="fixed bottom-4 left-0 right-0 text-center">
        <p className="text-sm text-gray-500">
          © {new Date().getFullYear()} Alliance Solidarité - L'Alliance Humaine 2020
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
